/* Verhindert, dass die Seite beim Wählen einer Option springt. Sobald der Nutzer selbst scrollt, wird sofort freigegeben. */
(function () {
  var lockY = null, until = 0, user = false, HOLD = 700;
  var SEL = '.gpo-app, variant-selects, variant-radios';
  function inOpt(e) { return e.target && e.target.closest && e.target.closest(SEL); }
  function lock() { lockY = window.scrollY; until = Date.now() + HOLD; user = false; }
  function release() { user = true; lockY = null; }
  ['wheel', 'touchstart', 'touchmove', 'keydown', 'pointerdown'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      if (t === 'wheel' || t === 'touchmove') { release(); return; }
      if (inOpt(e)) return;
      release();
    }, { passive: true });
  });
  window.addEventListener('scroll', function () {
    if (lockY === null || user || Date.now() > until) return;
    if (Math.abs(window.scrollY - lockY) > 2) window.scrollTo({ top: lockY, left: 0, behavior: 'instant' });
  }, { passive: true });
  document.addEventListener('pointerdown', function (e) { if (inOpt(e)) lock(); }, true);
  document.addEventListener('keydown', function (e) { if (inOpt(e)) lock(); }, true);
  document.addEventListener('change', function (e) {
    if (!inOpt(e)) return;
    if (lockY === null || Date.now() > until) lock(); else until = Date.now() + HOLD;
  }, true);
})();
